import { Type, plainToClass } from 'class-transformer';

import { TargetFieldConditionalLogicInstructions } from './target-field-logic-instructions';

export class FormInstanceLoadedConditionalLogicInstructions {
    public formInstanceId: number;

    @Type(() => TargetFieldConditionalLogicInstructions)
    public targetFieldInstructions: TargetFieldConditionalLogicInstructions[];
}
